import dayjs, { Dayjs } from 'dayjs';

export const genTestID = (component: Testing.Component, tag: string):Testing.TestId => `${component}-${tag}`;

export const getToken = () => {
  const tokenType = sessionStorage.getItem('TOKEN_TYPE');
  const tokenAPI = sessionStorage.getItem('TOKEN_API');
  return `${tokenType} ${tokenAPI}`;
};

export const compareString = (strA:string, strB:string) => {
  if (strA > strB) {
    return 1;
  }
  if (strA < strB) {
    return -1;
  }

  return 0;
};

export const sortNumber = (a: number, b: number) => a - b;

/**
 * Parse number string with thousand separator.
 * Reference: https://stackoverflow.com/a/45309230/11812422
 * eg. "11,111.11" -> 11111.11
 * @param value String of number
 * @returns Number without thousand separator
 */
export const parseNumber = (value: string) => {
  let normalized = value;
  const example = Intl.NumberFormat('en-US').format(1.1);
  const cleanPattern = new RegExp(`[^-+0-9${example.charAt(1)}]`, 'g');
  const cleaned = value.replace(cleanPattern, '');
  normalized = cleaned.replace(example.charAt(1), '.');

  return parseFloat(normalized);
};

/**
 * Turn normal number into locale formatted string
 * eg. 11111.00 -> "11,111.00"
 * @param value any number
 * @returns Locale number string with 2 dp
 */
export const formatLocaleNumber = (value: number) => {
  return Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);
};

export const formatCurrency = (value: number | string | undefined | null) => {
  if (typeof value === 'number') {
    return `RM ${formatLocaleNumber(value)}`;
  }
  return `RM ${value || 0}`;
};

export const compareDate = (dateStrA:string, dateStrB:string) => {
  const dateA = dayjs(dateStrA);
  const dateB = dayjs(dateStrB);

  if (dateA.isAfter(dateB)) {
    return 1;
  }
  if (dateA.isBefore(dateB)) {
    return -1;
  }

  return 0;
};

// TODO: maybe can improve the type for mimeType param
export const downloadAs = (blob: BlobPart, filename: string, mimeType: string) => {
  const url = window.URL.createObjectURL(
    new Blob([blob], { type: mimeType }),
  );
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute(
    'download',
    filename,
  );
  document.body.appendChild(link);
  link.click();
};

export const formatDate = (date: Nullable<string | Dayjs>, showTime: boolean = false) => {
  if (!date) {
    return 'Date Error';
  }
  const dayjsDate = dayjs(date);
  const format = showTime ? 'DD MMM YYYY H:mm:ss a' : 'DD MMM YYYY';
  return dayjsDate.format(format);
};

export const formatInputDate = (date: Nullable<string | Dayjs>) => {
  if (!date) {
    return 'Date Error';
  }
  const dayjsDate = dayjs(date);
  const format = 'YYYY-MM-DD HH:mm:ss';
  return dayjsDate.format(format);
};

export const getSelectedOptionValue = (value:string, options?:Inputs.SelectOption[]) => {
  if (options) {
    return options.find((option) => option.label === value)?.value;
  }
  return null;
};

export const sortOptionAsc = (a: Inputs.SelectOption, b: Inputs.SelectOption) => {
  if (a.label < b.label) {
    return -1;
  }
  if (a.label > b.label) {
    return 1;
  }
  return 0;
};

export const blobToBase64 = (blob: Blob, callback: (dataUrl: string, base64: string) => void) => {
  const reader = new FileReader();
  reader.onload = () => {
    const dataUrl = reader.result as string;
    const base64 = dataUrl.split(',')[1];
    callback(dataUrl, base64);
  };
  reader.readAsDataURL(blob);
};

export const range = (start: number, end: number) => {
  const result = [];
  for (let i = start; i < end; i += 1) {
    result.push(i);
  }
  return result;
};
